module.exports = __webpack_public_path__ + "static/media/food.4eaafa37.png";